// src/i18n/default.ts
var current = null;
function setDefaultI18n(reader) {
  current = reader;
}
function getDefaultI18n() {
  return current;
}

export { getDefaultI18n, setDefaultI18n };
//# sourceMappingURL=chunk-2UGAFJLN.js.map
//# sourceMappingURL=chunk-2UGAFJLN.js.map